// extracted by mini-css-extract-plugin
export default {"section_title":"SectionTitle_section_title__iXhYG"};